import dynamic from "next/dynamic";
const CustomerStoriesComponent = dynamic(()=>import("./customer-stories-component"));
import CustomerStoriesConfig from "./customer-stories-config";
import CustomerStoriesAdvancedConfig from "./customer-stories-advanced-config";
export default {
    CustomerStoriesComponent,
    CustomerStoriesConfig,
    CustomerStoriesAdvancedConfig
};
